export class User {
  constructor(
    public Username: string,
    public Password: string,
    public TFAoption: number,
    public TFAcode: string,
    public TestXMLLogin: boolean
  ) { }
}
